import React, { useState, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import './autocomplete.scss'

const InputAutoComplete = (props) => {
    const [inputValue, setInputValue] = useState('');
    return (
        <Autocomplete
            className={props.className}
            options={inputValue.length < 2 ? [] : props.options} // No mostrar opciones si no hay texto
            getOptionLabel={props.getOptionLabel}
            value={props.value}
            onChange={props.onChange}
            isOptionEqualToValue={props.isOptionEqualToValue}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
            renderInput={(params) => (
                <TextField {...params} label={props.placeholder} variant="outlined" />
            )}
            sx={{ width: 270 }}
            disabled={props.disabled}
        />
    );

}
export default InputAutoComplete;